import { Backdrop, Button, Fade, Modal } from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import { CloseIcon } from 'app/shared/icons';
import { IRootState } from 'app/shared/reducers';
import { Markup } from 'interweave';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './modal-rating.scss';

export interface IModalRatingProps {
    modal: boolean;
    title: string;
    message: string | string[];
    txtValidButton?: string;
    txtCancelButton?: string;
    handleOk?(data: any): void;
    handleCancel?(): void;
}
const ModalRating = (props: IModalRatingProps) => {
    const {
        modal,
        title,
        message,
        txtValidButton,
        handleOk,
        handleCancel,
    } = props;

    const { isMobile } = useSelector((state: IRootState) => state.cms);

    const [rate, setRate] = useState(0);
    const [description, setDescription] = useState('');

    const handleOkClick = () => {
        const data: any = {
            rating: rate,
            comment: description,
        };
        if (handleOk) {
            handleOk(data);
        }
    }

    const handleCancelClick = () => {
        if (handleCancel) {
            handleCancel();
        }
    }
    const handleChange = (event) => {
        const { value } = event.target
        setDescription(value);
    }

    const toArray = (value: any) => {
        if (!value) return;
        if (Array.isArray(value)) {
            return value;
        } else {
            return [value]
        }
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={"modal-container-rating" + (!isMobile ? " desktop-modal" : "")}
            open={modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={modal}>
                <div className="paper-info paper-info-rating">
                    <button className="close-button" onClick={handleCancelClick}>
                        <CloseIcon />
                    </button>
                    <br />
                    <div>
                        <div className={"paper-info-text "}>
                            <div className='h4'>
                                {title}
                            </div>
                            {toArray(message)?.map((msg, index) => {
                                return (
                                    <div key={index} className='h5'>
                                        <Markup noWrap content={msg} />
                                    </div>
                                );
                            })}
                        </div>
                        <div className="rating-section">
                            <Rating
                                name="simple-controlled"
                                value={rate}
                                style={{
                                    fontSize: "4rem"
                                }}
                                onChange={(event, newValue) => {
                                    setRate(newValue ? newValue : 0);
                                }}
                            />
                        </div>
                        <textarea
                            className="form-control rating-comment"
                            value={description}
                            onChange={(event) => handleChange(event)}
                            name="description"
                            rows={4}
                            placeholder={"Dîtes-nous ce que vous en pensez :"}
                        />
                        <br />
                        <div className="row row-button">
                            <div className="col-3">
                                <Button variant="contained"
                                    className="btn btn-block"
                                    disabled={rate === 0}
                                    onClick={handleOkClick}
                                    disableElevation>
                                    {txtValidButton}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}
export default ModalRating;


